module.exports = {"TXTCLI_Free_Spins":{"id":"TXTCLI_Free_Spins","defaultMessage":"Free spins","track":"Free Spins"}}